// import { Component } from '@theme/component';
// import Swiper from '@theme/swiper-core';
// /**
//  * @typedef {Object} SwiperCarouselRefs
//  * @property {HTMLElement} swiper - Swiper
//  */

// /**
//  * A custom element that manages the showing and hiding excess content items
//  *
//  * @extends {Component<SwiperCarouselRefs>}
//  */

// class SwiperComponent extends Component {
//   /**
//    * Pauses the media
//    */
//   pauseAllMedia() {
//     this.querySelectorAll('deferred-media').forEach((deferredMedia) => {
//       // @ts-ignore
//       deferredMedia?.pauseMedia();
//     });
//   }

//   // @ts-ignore
//   startCurentMedia(swiper) {
//     const realIndex = swiper.activeIndex;
//     const currentSlide = swiper.slides[realIndex];
//     if (!currentSlide) return;
//     const currentMedia = currentSlide.querySelector('deferred-media');
//     if (!currentMedia) return;
//     if (currentMedia.hasAttribute('data-media-loaded')) {
//       currentMedia.playMedia();
//     } else {
//       currentMedia.showDeferredMedia();
//     }
//   }

//   connectedCallback() {
//     super.connectedCallback();
//     const { swiper } = this.refs;
//     // const swiper = this.querySelector('.swiper');
//     this.options = JSON.parse(this.querySelector(':scope > [type="application/json"]')?.textContent || '{}');

//     // @ts-ignore
//     this.swiper = new Swiper(swiper, {
//       ...this.options,
//       on: {
//         resize: () => {}
//       }
//     });
//     // @ts-ignore
//     this.swiper.on('slideChangeTransitionStart', (swiper) => {
//       this.pauseAllMedia();
//       this.startCurentMedia(swiper);
//       this.#init();
//     });

//     this.#init();
//   }

//   disconnectedCallback() {
//     this.swiper?.destroy(true, true);
//   }

//   updatedCallback() {
//     // this.swiper?.update();

//     this.swiper?.destroy(true, true);
//     this.swiper = new Swiper(this.refs.swiper, this.options);
//   }

//   #init() {
//     const params = new URLSearchParams(document.location.search);
//     const param = params.get('slide');
//     if (!param) return;

//     const slide = document.querySelector(`.${param}`);
//     if (!slide) return;

//     const index = this.swiper.slides.indexOf(slide);
//     if (!index) return;

//     this.swiper.slideTo(index);
//     this.#scrollTo();

//     setTimeout(() => {
//       const url = new URL(window.location.href);
//       url.searchParams.delete('slide');
//       window.history.pushState({}, document.title, url.toString());
//     }, 1000);
//   }

//   #scrollTo() {
//     const top = this.closest('.shopify-section')?.getBoundingClientRect().top;
//     if (top) {
//       const headerHeight = document.querySelector('#header-component[sticky="always"]')?.clientHeight || 0;
//       window.scrollTo({ top: top + window.scrollY - headerHeight, behavior: 'smooth' });
//     }
//   }
// }

// if (!customElements.get('swiper-component')) {
//   customElements.define('swiper-component', SwiperComponent);
// }

import { Component } from '@theme/component';
import Swiper from '@theme/swiper-core';

class SwiperComponent extends Component {
  #observer;
  #initialized = false;

  pauseAllMedia() {
    this.querySelectorAll('deferred-media').forEach((deferredMedia) => {
      deferredMedia?.pauseMedia();
    });
  }

  startCurentMedia(swiper) {
    const currentSlide = swiper.slides[swiper.activeIndex];
    if (!currentSlide) return;
    const currentMedia = currentSlide.querySelector('deferred-media');
    if (!currentMedia) return;
    if (currentMedia.hasAttribute('data-media-loaded')) {
      currentMedia.playMedia();
    } else {
      currentMedia.showDeferredMedia();
    }
  }

  #parseOptions() {
    try {
      return JSON.parse(this.querySelector(':scope > [type="application/json"]')?.textContent || '{}');
    } catch (e) {
      console.error('swiper-component: invalid options JSON', e);
      return {};
    }
  }

  #createSwiper() {
    this.swiper = new Swiper(this.refs.swiper, this.options);
    this.swiper.on('slideChangeTransitionStart', (swiper) => {
      this.pauseAllMedia();
      this.startCurentMedia(swiper);
    });
    this.#initialized = true;
    this.#init();
  }

  connectedCallback() {
    super.connectedCallback();
    this.options = this.#parseOptions();

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.#createSwiper();
          this.#observer.disconnect();
        }
      },
      { rootMargin: '300px 0px' }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.swiper?.destroy(true, true);
  }

  updatedCallback() {
    this.options = this.#parseOptions();
    // Only rebuild if it was already live — an off-screen carousel that
    // hasn't initialized yet will pick up the fresh options whenever it does.
    if (this.#initialized) {
      this.swiper?.destroy(true, true);
      this.#createSwiper();
    }
  }

  #init() {
    const params = new URLSearchParams(document.location.search);
    const param = params.get('slide');
    if (!param) return;

    const slide = document.querySelector(`[data-slide="${param}"]`);
    if (!slide) return;

    const index = this.swiper.slides.indexOf(slide);
    if (index === -1) return;

    this.swiper.slideTo(index);
    this.#scrollTo();

    setTimeout(() => {
      const url = new URL(window.location.href);
      url.searchParams.delete('slide');
      window.history.pushState({}, document.title, url.toString());
    }, 1000);
  }

  #scrollTo() {
    const top = this.closest('.shopify-section')?.getBoundingClientRect().top;
    if (top) {
      const headerHeight = document.querySelector('#header-component[sticky="always"]')?.clientHeight || 0;
      window.scrollTo({ top: top + window.scrollY - headerHeight, behavior: 'smooth' });
    }
  }
}

if (!customElements.get('swiper-component')) {
  customElements.define('swiper-component', SwiperComponent);
}
